/* eslint-disable arrow-body-style */
/* eslint-disable import/extensions */
/* eslint-disable import/order */
/* eslint no-use-before-define: 0 */
import React from "react";

const Table = ({ attributes, children, element }) => {
  return (
    <table>
      <tbody {...attributes}>{children}</tbody>
    </table>
  );
};

export default Table;
